<template>
  <div class="border-static-default-low rounded-lg grow border p-16">
    <h2 class="heading-2">{{ title }}</h2>
    <p v-if="subtitle" class="body-2">{{ subtitle }}</p>

    <InteractiveRating
      v-model="rate"
      class="mt-8"
      :name="id"
      @set-rate="handleSetRate"
      @update:model-value="(value) => onRateChange(value)"
    />

    <p v-if="!!rateText" class="body-1 mt-8">{{ rateText }}</p>

    <p v-if="!!errorMessage" class="text-static-danger-hi mt-8">
      {{ errorMessage }}
    </p>

    <CareModal :name="REVIEW_FORM_CARE_MODAL" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { openModal } from '@ds/components/ModalBase'

import { NEGATIVE_REVIEW_MAX_LIMIT } from '../../ReviewCollection.constants'
import CareModal from '../Care/CareModal.vue'
import InteractiveRating from '../InteractiveRating/InteractiveRating.vue'

const REVIEW_FORM_CARE_MODAL = 'go_help_center_review_form'

defineProps<{
  id: string
  title: string
  subtitle?: string
  errorMessage?: string
}>()

const rate = defineModel<number>()
const rateText = ref('')

defineEmits<{
  (e: 'update:modelValue', rate: number): void
}>()

function handleSetRate(text: string) {
  rateText.value = text
}

function onRateChange(value: number) {
  if (value <= NEGATIVE_REVIEW_MAX_LIMIT) {
    openModal(REVIEW_FORM_CARE_MODAL)
  }
}
</script>
